module.exports = __webpack_public_path__ + "assets/fonts/CircularXXWeb-Italic.woff";